import './transporter_details.css';
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { ADD_TRANSPORTER, authKey, GET_CONFIG_BY_SERVICE_TYPE } from '../../../../common/URLs';

import { loaderService } from '../../../../common/custom-loader/loader-service';
import { Button } from '@mui/material';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { Container, Card, Autocomplete, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { DataGrid, GridToolbarQuickFilter, GridToolbarExport, GridEditInputCell, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { VehicleValidation } from '../../../../common/commonValidations';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { PreRegPopover } from '../../../../common/commonPopovers/preRegPopver';
import { ArrowBackIosNewIcon, SubmitIcon } from '../../../../common/icons';
import apiClient from '../../../../axios';

const VehicleDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? null : jwt(getLocalStorageItem('id_token')) : null;
    const [detailsFromPrevPage, setDetailsFromPrevPage] = useState({});
    const [transporterDetails, settransporterDetails] = useState();
    const [transporterError, setTransporterError] = useState('');
    const [selectedArea, setSelectedArea] = useState([]);
    const [mobileValidation, setMobileValidation] = useState(true);
    const [areaOfOperationsArr, setAreaOfOperationsArr] = useState([]);
    const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
    const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
    const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);
    const [logModalOpenSuccess, setLogModalOpenSuccess] = useState(false);
    const handleLogModalSuccessOpen = () => setLogModalOpenSuccess(true);
    const handleLogModalSuccessClose = () => setLogModalOpenSuccess(false);
    // const areaOfOperationsArr = ["Area1", "Area2", "Area3", "Area4", "Area5", "Area6", "Area7", "Area8"]
    const [errorMessage, setErrorMessgae] = useState({
        noOfVehicleError: '',
        areaErr: ''
    });

    const [noOfVehicles, setNoOfVehicles] = useState({
        noOfLcvVehicleOwned: '',
        noOfMcvVehicleOwned: '',
        noOfHcvVehicleOwned: '',
        noOfLcvVehicleRented: '',
        noOfMcvVehicleRented: '',
        noOfHcvVehicleRented: '',

    });
    const [vehicleData, setVehicleData] = useState([
        {
            vehicleType: t('preReg.lcv'),
            ownedVehicles: '',
            rentedVehicles: ''
        },
        {
            vehicleType: t('preReg.hcv'),
            ownedVehicles: '',
            rentedVehicles: ''
        },
        {
            vehicleType: t('preReg.mcv'),
            ownedVehicles: '',
            rentedVehicles: ''
        },
    ]);

    useEffect(() => {
        setDetailsFromPrevPage(location.state.data);
        // setNoOfVehicles({
        //     ...noOfVehicles,
        //     noOfLcvVehicleOwned: detailsFromPrevPage.noOfLcvVehicleOwned,
        //     noOfMcvVehicleOwned: detailsFromPrevPage.noOfMcvVehicleOwned,
        //     noOfHcvVehicleOwned: detailsFromPrevPage.noOfHcvVehicleOwned,
        //     noOfLcvVehicleRented: detailsFromPrevPage.noOfLcvVehicleRented,
        //     noOfMcvVehicleRented: detailsFromPrevPage.noOfMcvVehicleRented,
        //     noOfHcvVehicleRented: detailsFromPrevPage.noOfHcvVehicleRented,
        // })

        setVehicleData(detailsFromPrevPage?.vehicleData ? detailsFromPrevPage?.vehicleData : [
            {
                vehicleType: t('preReg.lcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
            {
                vehicleType: t('preReg.hcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
            {
                vehicleType: t('preReg.mcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
        ]);
        if (transporterDetails) {
            if (transporterDetails.transporterDetail) {
                handleLogModalSuccessOpen();
            }
            if(!transporterDetails?.isSuccess) {
                toast.error(transporterDetails?.message)
            }
        }
    }, [transporterDetails]);

    useEffect(() => {
        // setNoOfVehicles({
        //     ...noOfVehicles,
        //     noOfLcvVehicleOwned: detailsFromPrevPage?.noOfLcvVehicleOwned,
        //     noOfMcvVehicleOwned: detailsFromPrevPage?.noOfMcvVehicleOwned,
        //     noOfHcvVehicleOwned: detailsFromPrevPage?.noOfHcvVehicleOwned,
        //     noOfLcvVehicleRented: detailsFromPrevPage?.noOfLcvVehicleRented,
        //     noOfMcvVehicleRented: detailsFromPrevPage?.noOfMcvVehicleRented,
        //     noOfHcvVehicleRented: detailsFromPrevPage?.noOfHcvVehicleRented,
        // })

        setVehicleData(detailsFromPrevPage?.vehicleData ? detailsFromPrevPage?.vehicleData : [
            {
                vehicleType: t('preReg.lcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
            {
                vehicleType: t('preReg.hcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
            {
                vehicleType: t('preReg.mcv'),
                ownedVehicles: '',
                rentedVehicles: ''
            },
        ])
        setSelectedArea(detailsFromPrevPage?.existingAreaOfOperation ? detailsFromPrevPage?.existingAreaOfOperation : [])

    }, [detailsFromPrevPage]);

    const onCancel = (e) => {
        e.preventDefault();
        const dataToBePassed = {
            "vehicleData": vehicleData,
            "existingAreaOfOperation": selectedArea,
        }
        navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/transporter_details' : '/preregistration/transporter_details', { state: { data: dataToBePassed, mobileValidation: mobileValidation } })
    }

    // const onChangeNoOfVehicle = (e) => {
    //     setNoOfVehicles({ ...noOfVehicles, [e.target.name]: totalNumberOfClumpValidation(e.target.value) })
    //     if (e.target.value.length > 0) {
    //         setErrorMessgae({ ...errorMessage, noOfVehicleError: '' })
    //     }
    // }

    const gettransporterDetails = () => {
        handleLogModalConfirmClose();

        //if (vehicleData.some(obj => obj.ownedVehicles || obj.rentedVehicles)
        //) {
            if (selectedArea && selectedArea?.length > 0) {
                loaderService.showLoader();
                let headers = {
                    AuthKey: authKey,
                }
                if (getLocalStorageItem('id_token')) {
                    headers = {
                        AuthKey: authKey,
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
                apiClient
                    .post(ADD_TRANSPORTER,
                        {
                            "applicantType": detailsFromPrevPage.applicantType,
                            "name": detailsFromPrevPage.name,
                            "contactPersonFirstname": detailsFromPrevPage.contactPersonFirstname,
                            "contactPersonMiddlename": detailsFromPrevPage.contactPersonMiddlename,
                            "contactPersonLastname": detailsFromPrevPage.contactPersonLastname,
                            "contactPersonGender": detailsFromPrevPage.contactPersonGender,
                            "contactPersonSalutation": detailsFromPrevPage.contactPersonSalutation,
                            "mobileNo": detailsFromPrevPage.mobileNo,
                            "emailId": detailsFromPrevPage.emailId,
                            "pincode": detailsFromPrevPage.pincode,
                            "address": detailsFromPrevPage.address,
                            "state": detailsFromPrevPage.state,
                            "district": detailsFromPrevPage.district,
                            "subDivision": detailsFromPrevPage.subDivision,
                            "noOfLcvVehicleOwned": vehicleData.find((item) => item.vehicleType === "LCV").ownedVehicles,
                            "noOfLcvVehicleRented": vehicleData.find((item) => item.vehicleType === "LCV").rentedVehicles,
                            "noOfMcvVehicleOwned": vehicleData.find((item) => item.vehicleType === "MCV").ownedVehicles,
                            "noOfMcvVehicleRented": vehicleData.find((item) => item.vehicleType === "MCV").rentedVehicles,
                            "noOfHcvVehicleOwned": vehicleData.find((item) => item.vehicleType === "HCV").ownedVehicles,
                            "noOfHcvVehicleRented": vehicleData.find((item) => item.vehicleType === "HCV").rentedVehicles,
                            "existingAreaOfOperation": selectedArea,
                            "revenueCircle": detailsFromPrevPage.revenueCircle,
                            "blockName": detailsFromPrevPage.blockName,
                            "isOtpValidated": true,
                            "acceptedTerms": detailsFromPrevPage.acceptedTerms
                        },
                        {
                            headers: headers,
                        }
                    )
                    .then((response) => {
                        if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                            setMobileValidation(false);

                        }
                        settransporterDetails(response.data);
                        loaderService.hideLoader()
                    })
                    .catch(function (error) {
                        setTransporterError(error);
                        loaderService.hideLoader()
                    });
            } else setErrorMessgae({ ...errorMessage, areaErr: "Please select at least one area" })
        //}
        //else setErrorMessgae({ ...errorMessage, noOfVehicleError: "Please enter at least one vehicle" })
    }
    const handleAreaChange = (e, value) => {
        setSelectedArea(value);
        setErrorMessgae({ ...errorMessage, areaErr: '' })
    }

    const confirmSubmission = (e) => {
        e.preventDefault();
        handleLogModalConfirmOpen();
    }

    useEffect(() => {
        getAreasOfOperation();
    }, []);


    const getAreasOfOperation = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONFIG_BY_SERVICE_TYPE,
                {
                    "serviceType": "Transporter"
                },
                {
                    headers: {
                        AuthKey: authKey,
                    }
                }, null
            )
            .then((response) => {
                // setAreaOfOperationsArr(response.data.configs);
                let filteredData = response.data.configs.filter(item => item.appKey === 'AreaOfOperation');
                let data = filteredData[0].value.split(',')
                setAreaOfOperationsArr(data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    

    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

     function EditInputCell(props) {
           const { error, id, value: valueProp, field } = props;
           const [value, setValue] = useState(valueProp);
           const apiRef = useGridApiContext();
   
           const handleChange = (event) => {
               const newValue = event.target.value; 
               apiRef.current.setEditCellValue({ id, field, value: newValue });
               setValue(newValue);
           };
   
           useEffect(() => {
               setValue(valueProp);
           }, [valueProp]);
           
           return (
               <StyledTooltip open={!!error} title={error}>
                   <GridEditInputCell {...props} value={value} onChange={handleChange} />
              </StyledTooltip>
           );
       }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const columns = [
        {
            field: 'vehicleType',
            headerName: t('preReg.vehicleType'),
            width: 166
        },
        {
            field: 'ownedVehicles',
            headerName: t('preReg.ownedVehicle'),
            width: 190,
            type: "number",
            editable: true,
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: VehicleValidation(params.props.value, 5, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'rentedVehicles',
            headerName: t('preReg.rentedVehicle'),
            width: 197,
            type: "number",
            editable: true,
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: VehicleValidation(params.props.value, 5, 2) };
            },
            renderEditCell: renderEdit,
        },
    ]

    const processRowUpdate = (newRow) => {
        vehicleData.forEach((item) => {
            if (item.vehicleType === newRow.vehicleType) {
                item.ownedVehicles = newRow.ownedVehicles
                item.rentedVehicles = newRow.rentedVehicles
            }
        })
        setErrorMessgae({ ...errorMessage, noOfVehicleError: '' })
        return newRow

    };

    const onCellEditStop = (params, event) => {
        setVehicleData(vehicleData.map((item) => {
            if (item.vehicleType === params.row.vehicleType) {
                item[params.field] = event.target.value
            }
            return item
        }))
        setErrorMessgae({ ...errorMessage, noOfVehicleError: '' })
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG14</p>}
                <Card>
                    <CardContent>
                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                            {t('preReg.vehicleDetails')}
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={7}>

                                <Box mb={2} sx={{
                                    '& .super-app-theme--header': {
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-all',
                                        whiteSpace: 'initial',
                                    },
                                    '& .MuiDataGrid-cell--editable': {
                                        bgcolor: (theme) =>
                                            theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                    },
                                    '& .super-app.confirmationStatusPending': {
                                        backgroundColor: '#FFFF8F',
                                        color: '#1a3e72',
                                        fontWeight: '600',
                                    },
                                    '& .super-app.confirmationStatusRejected': {
                                        backgroundColor: '#F88379',
                                        color: '#1a3e72',
                                        fontWeight: '600',
                                    },
                                    '& .super-app.confirmationStatusConfirmed': {
                                        backgroundColor: '#ECFFDC',
                                        color: 'green',
                                        fontWeight: '600',
                                    },
                                    '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
                                }}>
                                   
                                        <DataGrid
                                            autoHeight
                                            rows={vehicleData}
                                            pagination={false}
                                            hideFooterPagination
                                            columns={columns}
                                            disableColumnMenu={true}
                                            experimentalFeatures={{ newEditingApi: true }}
                                            getRowId={(row) => row.vehicleType}
                                            processRowUpdate={(e) => processRowUpdate(e)}
                                        // onCellEditStop={(params, event) => {
                                        //     if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                                        //         event.defaultMuiPrevented = true;
                                        //     } onCellEditStop(params, event)
                                        // }}
                                        />
                                    
                                </Box>
                                <div className='mandatory_field'>{errorMessage.noOfVehicleError}</div>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={areaOfOperationsArr}
                                    value={selectedArea}
                                    onChange={(e, value) => handleAreaChange(e, value)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={errorMessage.areaErr}
                                            helperText={errorMessage.areaErr}
                                            required
                                            label={t('preReg.areasOfOperation')}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={(e) => onCancel(e)}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<SubmitIcon />} onClick={(e) => confirmSubmission(e)}>{t('preReg.submit')}</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={logModalOpenConfirm} onConfirm={gettransporterDetails} action="Submit" onClose={handleLogModalConfirmClose} />
            <PreRegPopover onOpen={logModalOpenSuccess} onClose={handleLogModalSuccessClose} urn={transporterDetails?.transporterDetail?.regStakeholderMaster.urn} message="Transporter created successfully" navigate={navigate} navigatePath={decoded != null && decoded && decoded.emails && decoded.emails[0] ? '/registrationHome/dashboard' : '/'} />
        </>
    )

}
export default VehicleDetails;